import React, { FC, useEffect, useState } from "react"
import _ from 'lodash'
// Components
import DropdownInput from "components/inputs/dropdown"
// Data
import chartService from "data/chart"
import propertyReportService from "data/reports-property"
// Styles
import { Button_s, Label_s } from "styles/app-styles"
import { ReportForm_s } from "styles/report-styles"
import { FormError_s } from "styles/form-styles"
import styled from "styled-components"


const DropdownInput_s = styled(DropdownInput)`
  width: 350px;
`

const ChartDetails: FC = () => {
  const [data, setData] = useState<number|null>(null)
  const [charts, setCharts] = useState<object[]|null>(null);

  useEffect(() => {
    const chartSubscription = chartService.stream().subscribe(data => {
      if (data.state === "ok" && data.value.length > 0){
        setCharts(data.value)
        setData(_.find(data.value, {'isdefault': true})['chartid'] || null)
      }
    })
  
    chartService.fetchCharts()

    return function cleanup() {
      chartSubscription.unsubscribe()
    }
  }, [])

  function submit():void {
    propertyReportService.propertyReport({
      report: 'chart_detail',
      params: {
        chart: [data]
      }
    });
  }

  const chartOptions = charts?.sort().map(chart => { return { label: `${chart['code']} ${chart['name'] ? '-' : ''} ${chart['name'] || ''}`, value: chart['chartid'] }})

  return (
    <div>
      <Button_s primary disabled={!data} onClick={() => submit()}>Run Report</Button_s>
      <ReportForm_s>
        <div style={{marginTop: '20px'}}>
          {!data && <FormError_s>Please select a chart to run report</FormError_s>}
          <Label_s>Select Chart</Label_s>
          <DropdownInput_s
            persist={(field:string, val:number)=>setData(val)}
            field="periodicity"
            options={chartOptions || []}
            value={data || ''}
          />
        </div>
      </ReportForm_s>
    </div>
  )
}

export default ChartDetails